import styles from "./Progress.module.scss";

const Progress = ({ setMsg = "検索中です" }) => {
  return (
    <div className={styles.pnlProgress}>
      <table>
        <tbody>
          <tr>
            <td valign="middle">
              <img
                id="ImageProgress"
                className={styles.loadingGif}
                src="/common/assets/images/processing.gif"
              />
            </td>
            <td valign="middle" className={styles.btd}></td>
            <td valign="middle" className={styles.ltext}>
              {setMsg + "・・・"}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
export default Progress;
